<script>

import { Line } from "vue-chartjs";

export default {
  extends: Line,
  data() {
    return {
      gradient: null,
      gradient2: null
    };
  },
  mounted() {
    this.gradient = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);
    this.gradient2 = this.$refs.canvas
      .getContext("2d")
      .createLinearGradient(0, 0, 0, 450);

    this.gradient.addColorStop(0, "rgba(41, 98, 255, 0.5)");
    this.gradient.addColorStop(0.5, "rgba(41, 98, 255, 0.25)");
    this.gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

    this.gradient2.addColorStop(0, "rgba(0, 231, 255, 0.9)");
    this.gradient2.addColorStop(0.5, "rgba(0, 231, 255, 0.25)");
    this.gradient2.addColorStop(1, "rgba(0, 231, 255, 0)");

    this.renderChart(
      {
        labels: [
          "Ocak",
          "Şubat",
          "Mart",
          "Nisan",
          "Mayıs",
          "Haziran",
          "Temmuz",
           "Ağustos",
          "Eylül",
           "Ekim",
           "Kasım",
          "Aralık",

        ],
        datasets: [
          {
            label: "Katılımcı",
            borderColor: "#ee313a",
            pointBackgroundColor: "white",
            borderWidth: 2,
            backgroundColor: this.gradient,
            data: [0, 54, 61, 83, 30, 25, 42,17,33,22,71,38]
          },
          {
            label: "Etkinlik",
            borderColor: "#05CBE1",
            pointBackgroundColor: "white",
            borderWidth: 2,
            backgroundColor: this.gradient2,
            data: [0, 3, 1, 9, 2, 1, 5,6,7,4,8,9]
          }
        ]
      },
      { responsive: true, maintainAspectRatio: false }
    );
  }
};
</script>